export const partners = [
  {
    name: 'Airbnb',
    logo: 'https://assets.maccarianagency.com/the-front/logos/airbnb.svg',
  },
  {
    name: 'Coinbase',
    logo: 'https://assets.maccarianagency.com/the-front/logos/coinbase.svg',
  },
  {
    name: 'Dribbble',
    logo: 'https://assets.maccarianagency.com/the-front/logos/dribbble.svg',
  },
  {
    name: 'Instagram',
    logo: 'https://assets.maccarianagency.com/the-front/logos/instagram.svg',
  },
  {
    name: 'Netflix',
    logo: 'https://assets.maccarianagency.com/the-front/logos/netflix.svg',
  },
  {
    name: 'Pinterest',
    logo: 'https://assets.maccarianagency.com/the-front/logos/pinterest.svg',
  },
];

export const services = [
  {
    icon: 'fas fa-magic',
    title: 'Spells',
    image: '/assets/fireball-2.png',
    link: '/runiverse/spells', 
    description: 'View all spells with stats, star levels, crafting costs, and workshop info.',
  },
  {
    icon: 'fas fa-shield-alt',
    title: 'Equipment',
    image: '/assets/moth-eclipse.png',
    link: '/runiverse/equipment',
    description: 'Browse gear sets, bonuses, and required materials to craft each piece.',
  },
  {
    icon: 'fas fa-dragon',
    title: 'Monster Drops',
    image: '/assets/monster-drops.png',
    link: '/runiverse/monster-drops',
    description: 'Track monsters and the rare materials they drop across all regions.',
  },
  {
    icon: 'fas fa-map-marked-alt',
    title: 'Resource Locations',
    image: '/assets/resources-ash.png',
    link: '/runiverse/resources',
    description: 'Find where to farm specific materials by region and category.',
  },

    {
    icon: 'fas fa-virus',
    title: 'Level Up Guide',
    image: '/assets/level-up-guide.png',
    link: '/runiverse/level-up-guide',
    description: 'Learn what is the fastest way to level from 1 to 25.',
  },
  {
    icon: 'fas fa-virus',
    title: 'Status Effects',
    image: '/assets/status-effects.png',
    link: '/runiverse/status-effects',
    description: 'Learn what status effects do and which spells or monsters apply them.',
  },
];




export const process = [
  {
    icon: 'fas fa-brain',
    title: '1. Idea',
    description:
      'We meet with your team to know more about your idea, project and goal. After that, our team sits to create an action plan and proposal for your project.',
  },
  {
    icon: 'fas fa-mobile-alt',
    title: '2. Design',
    description:
      'We start by designing a mockup or prototype of your website/app, and present it to you. Once with the initial mockup, we start the revision process to perfect it.',
  },
  {
    icon: 'fas fa-laptop-code',
    title: '3. Development',
    description:
      'We develop your website using the best practices and standards, so you have a perfectly responsive, lightning fast, and super scalable website.',
  },
  {
    icon: 'fas fa-cogs',
    title: '4. Launch & Maintenance',
    description:
      'When the project is ready, we help you to launch it and push it live. After that, we meet with your team to train them on how to edit, update and scale it.',
  },
];

export const work = [
  {
    title: 'Your Brand Platform',
    description:
      'Monetize your website and manage all guest interactions with your own brand, logo and domains.',
    illustration: 'https://assets.maccarianagency.com/the-front/illustrations/brand-platform.svg',
  },
  {
    title: 'Mobile Compatible Platform',
    description:
      'Introduce your brand-new mobile friendly website to your customers. Seamlessly integrates with WiFi hardware and marketing automation software.',
    illustration: 'https://assets.maccarianagency.com/the-front/illustrations/mobiles.svg',
  },
  {
    label: 'CLIENT PORTAL ACCESS',
    title: 'Simple Customer Dashboards',
    description:
      'Give sub-users access to a simplified dashboard with limited permission levels to offer remote management and real-time analytics.',
    illustration: 'https://assets.maccarianagency.com/the-front/illustrations/dashboard.svg',
  },
];

export const reviews = [
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams@2x.jpg 2x',
    },
    authorName: 'Veronica Adams',
    authorOccupation: 'Growth Marketer, Crealytics',
    feedback:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini@2x.jpg 2x',
    },
    authorName: 'Akachi Luccini',
    authorOccupation: 'Lead Generation, Alternative Capital',
    feedback:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  },
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith@2x.jpg 2x',
    },
    authorName: 'Jack Smith',
    authorOccupation: 'Head of Operations, Parkfield Commerce',
    feedback:
      'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  },
];
